import {treeRelativePath} from "seo/documentLang";

/**
 * Whether `pathname` is the activation page, `/activate/<token>`: where the activation email and a
 * purchase's Stripe return land. Read inside the language tree, because the storefront subfolders serve
 * it as `/de/activate/<token>` and `/ro/activate/<token>` (kitecorp/transferify-ui#3521).
 *
 * React-free (epic #26): the App shell asks it to keep the activation banner off the page that is
 * already doing the activating.
 */
export function isActivationRoute(pathname: string): boolean {
	return treeRelativePath(pathname).startsWith("/activate/");
}
